import React from 'react'
import { EditOutlined, EyeInvisibleOutlined, EyeOutlined } from '@ant-design/icons'
import { IChatMessage } from 'models/chat'
import { formatDateTime } from './utils'
import styles from './ChatsPage.module.scss'

interface IChatMessageMetaProps {
  message: IChatMessage
  onEdit?: () => void
  onMarkRead?: () => void
  onMarkUnread?: () => void
}

export const ChatMessageMeta: React.FC<IChatMessageMetaProps> = ({
  message,
  onEdit,
  onMarkRead,
  onMarkUnread
}) => (
  <div className={styles.messageMeta}>
    {onEdit && (
      <button
        type='button'
        className={styles.messageActionButton}
        onClick={onEdit}
        aria-label='Изменить сообщение'
        title='Изменить'
      >
        <EditOutlined />
      </button>
    )}
    {onMarkRead && (
      <button
        type='button'
        className={styles.messageActionButton}
        onClick={onMarkRead}
        aria-label='Пометить прочитанным'
        title='Пометить прочитанным'
      >
        <EyeOutlined />
      </button>
    )}
    {onMarkUnread && (
      <button
        type='button'
        className={styles.messageActionButton}
        onClick={onMarkUnread}
        aria-label='Пометить непрочитанным'
        title='Пометить непрочитанным'
      >
        <EyeInvisibleOutlined />
      </button>
    )}
    <span className={styles.messageTime}>
      {message.sender_name ? `${message.sender_name} · ` : ''}
      {message.edited_at ? 'изменено · ' : ''}
      {formatDateTime(message.createdAt)}
    </span>
  </div>
)
